import React from 'react';
import DraggableContain from '../../Componant/Calender/DraggableCalender';

const Calender = () => {
  return (
    <div className='page-body'>
      <DraggableContain />
    </div>
  );
};
export default Calender;
